module.exports = __webpack_public_path__ + "img/cs-1.acf17fea.jpg";